import React, { useState } from 'react'
import { ButtonCP } from 'submodules/nerit-framework-ui/common/components/button/ButtonCP'
import { ModalSamplingPointsCP } from 'modules/samplings/components/modal-sampling-points/ModalSamplingPointsCP'

interface ICPProps {
    samplingCode: number
}

export function ButtonModalSamplingPointsCP(props: ICPProps): JSX.Element {

    const [isModalVisible, setIsModalVisible] = useState<boolean>(false)

    return (
        <>
            <ButtonCP
                onClick={() => setIsModalVisible(true)}
                icon={'environment'}
                size={'small'}
            >
                Ver Pontos
            </ButtonCP>

            <ModalSamplingPointsCP
                visible={isModalVisible}
                onCancel={() => setIsModalVisible(false)}
                samplingCode={props.samplingCode}
            />
        </>
    )
}
